module.exports = __webpack_public_path__ + "img/3.81b977da.jpg";